// @flow

import React, { type Node } from 'react';
import styled, { css }  from 'styled-components';
import { useSubmitting } from '@tectonics/prs/submitting';

export function PlaceOrderButtonPix(): Node {
  const submitting = useSubmitting();

  return (
    <ButtonContentWrapper>
      <Button data-testid="submit-pix" disabled={submitting}>
        PIX Copia e cola
      </Button>
    </ButtonContentWrapper>
  );
}

const ButtonContentWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Button = styled.button`
  background: none;
  ${props => !props.disabled && css`
    border: 2px solid #333333;
  `}
  ${props => props.disabled && css`
    border: 2px solid #DFE3E7;
  `}
  border-radius: 6px;
  outline: none;
  font-size: 1.2em;
  font-weight: 600;
  font-family: "Open Sans","OpenSans",Arial,"Helvetica Neue",Helvetica,sans-serif;
  letter-spacing: 0.08em;
  overflow: hidden;
  text-align: center;
  text-decoration: none;
  text-overflow: ellipsis;
  text-transform: uppercase;
  padding: 1em 0.5em;
  transition: filter 200ms cubic-bezier(0, 0, 0.2, 1);
  width: 100%;
  cursor: pointer;
`;
